import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../api-models/common/json_query';

export function trackListingButtonClick(jsonQuery: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'ListView',
    sc: jsonQuery,
  });
}
